var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-tab-container"},[_c('div',{ref:"mainEl"},[_vm._t("default")],2),_vm._v(" "),_c('FixedContainer',{directives:[{name:"show",rawName:"v-show",value:(_vm.fixedRef),expression:"fixedRef"}]},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }